import { mergeStyles } from '@fluentui/react';
import { IPLayerHost } from 'baseComponents';

const layerHostClassContentAreaTop = mergeStyles({
  position: 'relative',
  width: '100%',
  height: 0,
  overflow: 'visible',
  zIndex: 900,
});

export default function AppRightSideBarLayerHost() {
  return <IPLayerHost id="layerHostContentAreaTop" className={layerHostClassContentAreaTop}></IPLayerHost>;
}
